import { memo } from "react";

const Dashboard = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.25 2.5H3.75C3.05964 2.5 2.5 3.05964 2.5 3.75V16.25C2.5 16.9404 3.05964 17.5 3.75 17.5H16.25C16.9404 17.5 17.5 16.9404 17.5 16.25V3.75C17.5 3.05964 16.9404 2.5 16.25 2.5Z"
      stroke="currentColor"
      strokeWidth="1.53846"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.0833 7.91665C12.0833 6.76605 11.1506 5.83331 10 5.83331C8.84941 5.83331 7.91667 6.76605 7.91667 7.91665V12.0833C7.91667 13.2339 8.84941 14.1666 10 14.1666C11.1506 14.1666 12.0833 13.2339 12.0833 12.0833V7.91665Z"
      stroke="currentColor"
      strokeWidth="1.53846"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default memo(Dashboard);
